<template>
  <div>
    <Card>
      <Row>
        <Button type="info" @click="add">新增</Button>
      </Row>
      <TablePaginate
        :columns="columns"
        :data="charge_coupons"
        :loading="loading"
        :meta="meta"
        :changePage="changePage"
      ></TablePaginate>
    </Card>
    <Modal v-model="modalShow" @on-ok="handleSubmit" title="新增">
      <Form ref="charge_coupon" :model="charge_coupon" :label-width="100">
        <Form-item label="充值数" prop="pay">
          <Input type="text" v-model="charge_coupon.pay" placeholder />
        </Form-item>
        <Form-item label="赠送数" prop="give">
          <Input type="text" v-model="charge_coupon.give" />
        </Form-item>
      </Form>
    </Modal>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
import { deleteButtonInTable, editorButtonInTable } from '@/libs/table-render'

export default {
  components: {
    TablePaginate
  },
  data () {
    return {
      modalShow: false,
      charge_modal: false,
      formType: '',
      price: 0,
      machoneCardId: '',
      columns: [
        {
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: '充值数',
          key: 'pay',
          align: 'center'
        },
        {
          title: '赠送数',
          key: 'give',
          width: 140,
          align: 'center'
        },
        {
          title: '创建时间',
          key: 'created_at_str',
          align: 'center',
          width: 200
        },
        {
          title: '操作',
          key: 'action',
          align: 'center',
          width: 200,
          render: (h, params) => {
            const children = []
            children.push(deleteButtonInTable(this, h, params))
            children.push(editorButtonInTable(this, h, params))
            return h('div', children)
          }
        }
      ]
    }
  },
  created () {
    this.index()
  },
  computed: {
    ...mapGetters('charge_coupon', [
      'charge_coupon',
      'charge_coupons',
      'meta',
      'loading'
    ])
  },
  methods: {
    ...mapActions('charge_coupon', [
      'clear',
      'index',
      'show',
      'create',
      'update',
      'destroy'
    ]),
    ...mapMutations('charge_coupon', ['changeQuery']),
    changePage (page) {
      this.changeQuery({ page: page, query: this.query })
      this.index()
    },
    add () {
      this.clear()
      this.modalShow = true
      this.formType = 'new'
    },
    handleSubmit () {
      if (this.formType === 'edit') {
        this.update(this.charge_coupon)
      } else if (this.formType === 'new') {
        this.create(this.charge_coupon)
      }
      this.modalShow = false
    }
  }
}
</script>
